import { render } from "./miscellaneous-services.svg?vue&type=template&id=720685b1?inline"
const script = {}
script.render = render

export default script